import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Container } from 'flux/utils';
import RegistrationStore from '../../stores/RegistrationStore';
import ModuleActions from '../../actions/ModuleActionCreator';
import { IconButton } from 'material-ui';
import RestoreIcon from 'material-ui/svg-icons/action/restore';
import SwitchRegistrationDialog from './SwitchRegistrationDialog';
import DialogActions from '../../actions/DialogActionCreator';
import { ModuleDialogs } from '../../constants/Dialogs';

class RegistrationHistory extends Component {

    componentDidMount() {
        this.loadRegistrations = this.loadRegistrations.bind(this);
    }

    componentWillMount() {
        this.loadRegistrations();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.userId !== this.props.userId || prevProps.moduleId !== this.props.moduleId) {
            this.loadRegistrations();
        }
    }

    loadRegistrations() {
        if (this.props.userId && this.props.moduleId) {
            ModuleActions.listRegistrationHistory(this.props.moduleId, this.props.userId);
        }
    }

    render() {
        if (!this.state.history || this.state.history.length === 0) { return null; }
        return (
            <div>
                Previous attempts: {this.state.history.length}
                {this.props.allowSwitch && (
                    <IconButton
                        label="Switch"
                        onTouchTap={() => DialogActions.open(ModuleDialogs.SWITCH_REGISTRATION_DIALOG)}
                    >
                        <RestoreIcon/>
                    </IconButton>
                )}
                <SwitchRegistrationDialog
                    history={this.state.history}
                    currentId={this.props.registrationId}
                />
            </div>
        );
    }
}

RegistrationHistory.getStores = () => ([RegistrationStore]);
RegistrationHistory.calculateState = (prevState, {userId, moduleId}) => ({
    isFetching: RegistrationStore.isFetching(),
    history: RegistrationStore.getHistory({moduleId, userId})
});

RegistrationHistory.propTypes = {
    userId: PropTypes.number.isRequired,
    moduleId: PropTypes.number.isRequired,
    registrationId: PropTypes.string,
    allowSwitch: PropTypes.bool,
};

RegistrationHistory.defaultProps = {
    allowSwitch: true
};

export default Container.create(RegistrationHistory, {withProps: true});
